const isSSR=()=>!("undefined"!=typeof window&&window.document);export default isSSR;